export const path = {
  createMessage: {
    route: "/messages/new",
    link: () => path.createMessage.route,
  },
};
